import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const items = [
  {
    id: "philosophy",
    title: "Educational Philosophy",
    body: "Returning to the education of the saints and creating a rhythm of prayer, work, and recreation while maintaining harmony and balance with family life.",
    cta: "Our Mission",
    img: "/assets/pillar-flame.png",
    to: "/about",
  },
  {
    id: "school-structure",
    title: "School Structure",
    lines: ["Flexible 2, 3 and 5 Day Enrollment Options"],
    cta: "School Format",
    img: "/assets/calendar-nav-gold.png",
    to: "/school-format",
  },
  {
    id: "tradition",
    title: "Rooted in Tradition",
    body: "A joyful rhythm ordered by prayer, the Holy Sacrifice of the Mass, and the Rosary forms hearts in the timeless spiritual traditions of the Church.",
    cta: "School Life",
    img: "/assets/chalice-gold.png",
    to: "/school-life",
  },
];

const NavyBand = () => {
  return (
    <section className="bg-[#1e2952] text-[#fbf7ee]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-6 lg:gap-0">
          {items.map((item, idx) => (
            <div
              key={item.id}
              className={`relative flex flex-col lg:flex-row items-center lg:items-center text-center lg:text-left gap-4 lg:gap-6 px-2 md:px-5 lg:px-8 xl:px-10 ${
                idx > 0 ? "md:pl-6 lg:pl-10 xl:pl-12" : ""
              }`}
            >
              {idx > 0 && (
                <span className="hidden md:block absolute left-0 top-[8%] bottom-[8%] w-px bg-[#c9a961]/45" />
              )}

              <div className="icon-wrap shrink-0 flex items-center justify-center" style={{ width: 96, height: 96 }}>
                <img src={item.img} alt="" className="w-20 h-20 lg:w-24 lg:h-24 object-contain" />
              </div>

              <div className="flex-1 min-w-0">
                <h4 className="font-sans-nav text-[13px] tracking-[0.24em] uppercase font-semibold mb-3 text-[#fbf7ee]">
                  {item.title}
                </h4>
                {item.lines ? (
                  <ul className="font-serif-body text-[15.5px] leading-[1.9] text-[#e8e2cf]">
                    {item.lines.map((l) => (
                      <li key={l}>{l}</li>
                    ))}
                  </ul>
                ) : (
                  <p className="font-serif-body text-[15.5px] leading-[1.7] text-[#e8e2cf] lg:max-w-[320px] mx-auto lg:mx-0">
                    {item.body}
                  </p>
                )}
                {item.cta && (
                  <Link
                    to={item.to}
                    className="inline-flex items-center gap-2 mt-4 font-sans-nav text-[11.5px] tracking-[0.28em] uppercase text-[#c9a961] hover:text-[#e2c98a] transition-colors"
                  >
                    {item.cta}
                    <ArrowRight size={14} />
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NavyBand;
